import React from 'react';
import cn from 'classnames';
import {
  DraggableContainer,
  PdfContainer,
  ImageContainer,
  MobileFullscreenContainer,
} from '../DraggableContainer';

import './styles.scss';

const PeriodicTable = ({
  periodicTable: {
    type,
    alt,
    url,
    maxWidth,
    minWidth,
    maxHeight,
    minHeight,
    ...props
  },
  onCloseClick,
  isMobile,
}) =>
  isMobile ? (
    <MobileFullscreenContainer {...props} onCloseClick={onCloseClick}>
      <PdfContainer {...{ url, name: 'periodic-table', isMobile }} />
    </MobileFullscreenContainer>
  ) : (
    <DraggableContainer {...props} onCloseClick={onCloseClick}>
      <div className={cn('periodic-table', { '--overflow': type !== 'pdf' })}>
        {type === 'pdf' ? (
          <PdfContainer
            {...{
              url,
              maxWidth,
              minWidth,
              maxHeight,
              minHeight,
              name: 'periodic-table',
            }}
          />
        ) : (
          <ImageContainer
            {...{ url, alt, maxWidth, minWidth, maxHeight, minHeight }}
          />
        )}
      </div>
    </DraggableContainer>
  );

export default PeriodicTable;
